import { fmlmReverseGeocode } from "../../../app/api/fmlmSearchLocation";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import { showNotification } from "../../../Services/notificationService";
import { ReverseGeocodeResult } from "../../LogicActions/FmlmSearch/FmlmGeoService";

export class FmlmCurrentLocationAction extends BaseAction<
  void,
  { longitude: number; latitude: number }
> {
  override async run(): Promise<void | null> {
    try {
      const { longitude, latitude } = this.params!;
      const response: IApiResponse<any> = await fmlmReverseGeocode(longitude, latitude);
      if (response.status === "ok") {
        const data = JSON.parse(response.answer);
        if (data?.features?.length > 0) {
          // Update reverse geocode location
          updateRecoilState<ReverseGeocodeResult>("fmlmReverseGeoCodeLocationAtom", {
            name: data?.features[0]?.properties?.name,
            place_formatted: data?.features[0]?.properties?.place_formatted,
            coordinates: data?.features[0]?.geometry.coordinates,
            country_code: data?.features[0]?.properties?.context?.country?.country_code,
          });

          // Update current location state
          updateRecoilState<ReverseGeocodeResult>("currentLocationAtom", {
            name: data?.features[0]?.properties?.name,
            place_formatted: data?.features[0]?.properties?.place_formatted,
            coordinates: data?.features[0]?.geometry.coordinates,
            country_code: data?.features[0]?.properties?.context?.country?.country_code,
          });
        } else {
          updateRecoilState("fmlmReverseGeoCodeLocationAtom", null);
          updateRecoilState("currentLocationAtom", null);
        }
      }
    } catch (error) {
      console.error("Error in FmlmCurrentLocationAction:", error);
      updateRecoilState("fmlmReverseGeoCodeLocationAtom", null);
      updateRecoilState("currentLocationAtom", null);
    }
  }
}

// Create a singleton instance
export const fmlmCurrentLocationAction = new FmlmCurrentLocationAction();
